/*
 * @LastEditors: caobopan
 * @LastEditTime: 2022-12-16 14:34:50
 * @Description: feature页面
 * @FilePath: /starmaker-starvr-officialnew/src/pages/home/components/header/index.js
 */

import weblogo from '../../img/web_logo.png'
import './index.scss';
const Header = (props) => {
  // const goLink = (link) => {
  //   window.open(link, "_blank")
  // }
  const menus = {
    front: { key: 'front', title: 'top' },
    aboutUs: { key: 'aboutUs', title: 'feature' },
    appDirection: { key: 'appDirection', title: 'gameplay' },
    productDesc: { key: 'productDesc', title: 'contact' },
  }
  const clickItem = (index) => {
    props.setActiveMenu(index)
  }
  return (
    <header className="header">
      <div className={'content-wrapper content'}>
        <img src={weblogo} alt="logo" />
        <nav className="nav">
          {
            Object.values(menus).map((menu, index) => (
              <div key={index} onClick={() => clickItem(index)}
                className={`a ${props.activeMenu === index ? 'active' : ''}`}
              >
                {menu.title}
              </div>
            ))
          }
        </nav>
      </div>
    </header>
  );
}

export default Header;
